import http, {download, uploadCfg} from "../../../utils/HttpUtils";

//
class CustomerService {
    //添加客户
    static async insert(data) {
        const apiUrl = "/base/customer/insert";
        return await http.post(apiUrl, data);
    }

    //修改客户
    static async update(data) {
        // console.log(data)
        const apiUrl = `/base/customer/update`;
        return await http.post(apiUrl, data);
    }

    //根据ID查询客户
    static async findOne(id) {
        const apiUrl = `/base/customer/findById/${id}`;
        return await http.get(apiUrl);
    }

    //分页查询客户
    static async findPage(data) {
        const apiUrl = "/base/customer/listPage";
        return await http.post(apiUrl, data);
    }


    //启用禁用
    static async enableOrDisable(data) {
        // console.log(id,status)
        const apiUrl = `/base/customer/update`;
        return await http.post(apiUrl,data);
    }

    //根据ID删除客户
    static async deleteOne(id) {
        const apiUrl = `/crms/customer/deleteOne/${id}`;
        return await http.get(apiUrl);
    }

    //新增客户账户信息
    static async insertAccount(data) {
        const apiUrl = "/crms/account/add";
        return await http.post(apiUrl, data);
    }

    //更新客户账户信息
    static async updateAccount(data) {
        const apiUrl = "/crms/account/edit/${data.id}";
        return await http.post(apiUrl, data);
    }

    //查询客户账户列表（所有）
    static async findAccountAll(id) {
        const apiUrl = `/base/customer/account/findAccountPage/${id}`;
        return await http.get(apiUrl);
    }

    //启用禁用
    static async accountEnableOrDisable(data) {
        const apiUrl = `/base/customer/account/enableOrDisable`;
        return await http.post(apiUrl,data);
    }
    //调整账户授信额度
    static async adjustAccount(data) {
        const apiUrl = `/base/customer/account/adjust`;
        return await http.post(apiUrl,data);
    }
    //账户充值
    static async fillAccount(data){
        const apiUrl = `/base/customer/account/recharge`;
        return await http.post(apiUrl,data);
    }
    //账户转账
    static async transferAccount(data){
        const apiUrl = `/base/customer/account/transfer`;
        return await http.post(apiUrl,data);
    }    
    //查询账户调额记录
    static async SupplierResizeLimitList(data){
        const apiUrl = `/base/customer/account/findAdjustPage`;
        return await http.post(apiUrl,data);
    }
    //查询账户转账记录
    static async SupplierTransferAccountsList(data){
        const apiUrl = `/base/customer/account/findTransferPage`;
        return await http.post(apiUrl,data);
    }
    //查询账户充值记录
    static async SupplierRechargeList(data){
        const apiUrl = `/base/customer/account/findRechargePage`;
        return await http.post(apiUrl,data);
    }        
    //导出数据
    static async export(res) {
        const apiUrl = "/base/customer/export";
        await download(apiUrl,res)
    }
    //下载模板
    static async downloadTpl() {
        const apiUrl = "/base/customer/downloadTpl";
        await download(apiUrl)
    }

    //获取导入配置
    static getImportCfg(cfg) {
        const apiUrl = "/base/customer/import";
        return uploadCfg(apiUrl, cfg);
    }
} 

export default CustomerService;
